import React, { useEffect, useState } from "react";
import { pelangganTable } from "./pelangganTable";
import { pelangganFormData } from "./pelangganFormData";

// API
import {
  getAllDataTablePelanggan,
  insertNewPelanggan,
  updatePelanggan,
  deletePelanggan,
} from "./api/pelangganAPI";
import { getDropdownPelangganJenis } from "views/admin/config/pelangganJenis/api/pelangganJenisAPI";

// Component
import CardTable from "components/Cards/CardTable";
import FormCustom from "components/Forms/FormCustom";
import ConfirmModal from "components/Modal/ConfirmModal";

import toast, { Toaster } from "react-hot-toast";
import { useHistory } from "react-router";

export default function Pelanggan() {
  const history = useHistory();

  const [addForm, setAddForm] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const [editFormValue, setEditFormValue] = useState(null);

  const [dataTable, setDataTable] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);

  const [active, setActive] = useState(false);

  const [formData, setFormData] = useState([]);

  const [formDataArr, setFormDataArr] = useState([]);

  // Select-Option Data
  const [dropdownPelangganJenis, setDropdownPelangganJenis] = useState([]);

  // type Search
  const [typeSearch, setTypeSearch] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [errors, setErrors] = useState(null);
  const [deletePopUp, setDeletePopUp] = useState({ show: false, id: null });

  // Component is Active ?
  useEffect(() => {
    setActive(true);
    return () => {
      setActive(false);
    };
  }, []);

  // Loading
  useEffect(() => {
    if (isLoading === true) {
      toast.loading("Data Diproses...");
    }
  }, [isLoading]);

  // handle when state active changed
  useEffect(() => {
    setIsLoading(true);

    getAllDataTablePelanggan()
      .then((response) => {
        active === true && setDataTable(response.data.data);
      })
      .catch((error) => console.error(`Error: ${error}`))
      .finally(setIsLoading(false));
  }, [active]);

  // Select-Option Data
  // Load Data Pelanggan Jenis
  useEffect(() => {
    setIsLoading(true);

    getDropdownPelangganJenis()
      .then((response) => {
        setDropdownPelangganJenis(response.data.data);
      })
      .catch((err) => setErrors(err))
      .finally(setIsLoading(false));

    return () => {
      setDropdownPelangganJenis([]);
    };
  }, [active]);
  // End Select-Option Data

  // Load Form Data Arr
  useEffect(() => {
    setFormDataArr(pelangganFormData(dropdownPelangganJenis));

    return () => {
      setFormDataArr([]);
    };
  }, [dropdownPelangganJenis]);

  // Clear Form Data When First Time Load Component
  useEffect(() => {
    setFormData(null);
  }, [active]);

  // Handle When User Click Add Button
  function handleInsert() {
    setActive(false);
    setAddForm(true);
  }

  // Handle When User Click Cancel Button
  const handleCancelButton = () => {
    setAddForm(false);
    setEditForm(false);
    setEditFormValue(null);
    setFormData(null);
    setActive(true);
  };

  // Handle When User Click Edit Button
  const handleEdit = (rowData) => {
    setActive(false);
    setEditFormValue(rowData);
    setEditForm(true);
  };

  // Handle When User Click Delete Button
  const handleDelete = (rowData) => {
    setDeletePopUp({
      show: true,
      id: rowData.id_pelanggan,
    });
  };

  // Handle When User Confirm to Delete Data
  const handleDeleteTrue = () => {
    setActive(false);
    if (deletePopUp.show && deletePopUp.id) {
      setIsLoading(true);

      deletePelanggan(deletePopUp.id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    }
  };

  // Handle When User Deny to Confirm Delete Data
  const handleDeleteFalse = () => {
    setDeletePopUp({
      show: false,
      id: null,
    });
  };

  // Handle When User Submit New Data
  const handleInsertSubmit = (e) => {
    e.preventDefault();

    setIsLoading(true);

    insertNewPelanggan(formData)
      .then((response) => setResult(response))
      .catch((err) => setErrors(err))
      .finally(endSubmitProcess());
  };

  // Handle When User Submit Update Data
  const handleUpdateSubmit = (e) => {
    e.preventDefault();

    if (formData !== null) {
      const id = editFormValue.id_pelanggan;

      setIsLoading(true);

      updatePelanggan(formData, id)
        .then((response) => setResult(response))
        .catch((err) => setErrors(err))
        .finally(endSubmitProcess());
    } else {
      toast.error(`Tidak ada data yang di ubah.`);
    }
  };

  // Check If Request Failed
  useEffect(() => {
    if (errors !== null) {
      toast.error(errors.message);
    }
  }, [errors]);

  // Check if Request Success
  useEffect(() => {
    if (result !== null) {
      if (result.data.success === true) {
        toast.success(result.data.message);
        setFormData(null);
        setAddForm(false);
        setEditForm(false);
        setActive(true);
        history.push("/masterData/Pelanggan");
      } else {
        let numericArray = [];
        for (let err in result.data.errors) {
          numericArray.push(result.data.errors[err]);
        }

        if (numericArray !== []) {
          toast.error(numericArray[0]);
        }
      }
      setResult(null);
    }

    return () => {
      setResult(null);
    };
  }, [history, result]);

  // Set Inputed Data to Form
  const setData = (key, value) => {
    return setFormData({ ...formData, [key]: value });
  };

  // Handle when submit process end
  const endSubmitProcess = () => {
    setDeletePopUp({ show: false });
    setIsLoading(false);
  };

  // Handle Search
  const handleSearch = (e) => {
    setTypeSearch(e.target.value);
  };

  // Handle when Searching Changes
  useEffect(() => {
    const getDataSearchResult = () => {
      getAllDataTablePelanggan(typeSearch)
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    const getData = () => {
      getAllDataTablePelanggan()
        .then((response) => {
          setDataTable(response.data.data);
        })
        .catch((error) => console.error(`Error: ${error}`))
        .finally(setIsLoading(false));
      setPageNumber(0);
    };

    let timer = setTimeout(() => {
      if (typeSearch) {
        getDataSearchResult();
      } else {
        getData();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [typeSearch]);

  // Handle When Page Change
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  if (addForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Tambah Data"}
              formDataArr={formDataArr}
              handleSubmit={handleInsertSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              // getData = {getData}
              editFormValue={null}
            />
          </div>
        </div>
      </div>
    );

  if (editForm === true)
    return (
      <div>
        <div className="flex flex-wrap mt-4">
          <div className="w-full mb-12 px-4">
            <Toaster />
            <FormCustom
              title={"Edit Data"}
              formDataArr={formDataArr}
              handleSubmit={handleUpdateSubmit}
              handleCancelButton={handleCancelButton}
              setData={setData}
              editFormValue={editFormValue}
            />
          </div>
        </div>
      </div>
    );

  return (
    <div>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          {deletePopUp.show && (
            <div>
              <ConfirmModal
                handleIfTrue={(e) => handleDeleteTrue()}
                handleIfFalse={(e) => handleDeleteFalse()}
              />
            </div>
          )}
          <Toaster />
          <CardTable
            tableTitle="Tabel Master Pelanggan"
            cols={pelangganTable(handleEdit, handleDelete)}
            handleInsert={(e) => handleInsert()}
            handleSearch={handleSearch}
            data={dataTable}
            pageNumber={pageNumber}
            changePage={changePage}
          />
        </div>
      </div>
    </div>
  );
}
